import { useEffect, useState } from 'react';
import { TestimonialCard, TestimonialDots } from './TestimonialCard';
import type { ITestimonial } from './types';

export interface ITestimonialsCarouselProps {
  testimonials: ITestimonial[];
  autoPlayMs?: number;
}

const DEFAULT_AUTO_PLAY_MS = 10_000;

export const TestimonialsCarousel = ({
  testimonials,
  autoPlayMs = DEFAULT_AUTO_PLAY_MS,
}: ITestimonialsCarouselProps) => {
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    if (testimonials.length <= 1) return undefined;
    const id = setInterval(() => {
      setCurrent((i) => (i + 1) % testimonials.length);
    }, autoPlayMs);
    return () => clearInterval(id);
  }, [testimonials.length, autoPlayMs]);

  if (testimonials.length === 0) return null;
  const active = testimonials[current];

  return (
    <div data-testid="testimonials-carousel">
      <TestimonialCard
        quote={active.quote}
        author={active.author}
        role={active.role}
        footer={<TestimonialDots total={testimonials.length} current={current} />}
      />
    </div>
  );
};
